module.exports = __webpack_public_path__ + "img/sampleGraph12.7cf41f0a.png";